module.exports = __webpack_public_path__ + "static/media/divan-franquia.bfa47ba5.png";